import { BLUE_600, GRAY_800, WHITE } from 'constants/styling/theme'
import { Slider, Typography } from '@mui/material'

import React from 'react'
import Stack from '@mui/material/Stack'
import { useMaskDrawer } from '../MaskDrawer'
import { useTranslation } from 'react-i18next'

/**
 * @component
 *
 * @example
 * <GenerateButtonToolbarExtension />
 */
export const GenerateButtonToolbarExtension: React.FC = () => {
  const { t } = useTranslation(['ai_studio_editing'])

  const { brushSize, setBrushSize } = useMaskDrawer()

  return (
    <Stack alignItems={'center'} display={'flex'} flexDirection={'row'}>

      <Typography variant='text-xs' fontWeight={500} color={WHITE} sx={{ paddingX: '1.6rem' }}>
        {t('brush_size')}
      </Typography>

      <Slider
        aria-label="magic eraser brush size"
        value={brushSize}
        onChange={(e, val) => setBrushSize(val as number)}
        min={1}
        max={100}
        style={{ width: 180, margin: '0 auto' }}
        sx={{
          color: BLUE_600,
          height: 8,
          '& .MuiSlider-track': {
            border: 'none',
            backgroundColor: BLUE_600,
          },
          '& .MuiSlider-rail': {
            backgroundColor: GRAY_800,
            opacity: 1,
          },
          '& .MuiSlider-thumb': {
            width: 12,
            height: 12,
            backgroundColor: '#fff',
            border: '0rem solid currentColor',
            position: 'relative',
            '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
              boxShadow: 'inherit',
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: '4px',
              height: '4px',
              borderRadius: '50%',
              backgroundColor: BLUE_600,
            },
          },
        }}
      />

    </Stack>
  )
}
